import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09857657"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = {
  class: "search-tab-bar",
  style: {"margin-bottom":"10px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tab-label" }, "聊天记录", -1))
const _hoisted_4 = { class: "tab-count" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tab-label" }, "客资信息", -1))
const _hoisted_6 = { class: "tab-count" }
const _hoisted_7 = { class: "results-panel" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 加载中... ")
const _hoisted_9 = {
  key: 1,
  class: "result-list"
}
const _hoisted_10 = { class: "card-main" }
const _hoisted_11 = { class: "msg-body" }
const _hoisted_12 = { class: "msg-title-row" }
const _hoisted_13 = {
  class: "visitor-name",
  style: {"margin-bottom":"2px"}
}
const _hoisted_14 = { style: {"color":"#969799","font-size":"13px"} }
const _hoisted_15 = {
  key: 0,
  class: "badge badge-orange"
}
const _hoisted_16 = { class: "visitor-tags" }
const _hoisted_17 = { class: "msg-count-label" }
const _hoisted_18 = { class: "msg-list" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "msg-snippet" }
const _hoisted_21 = { class: "msg-snippet-text" }
const _hoisted_22 = {
  key: 0,
  class: "hl"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 0,
  class: "msg-time"
}
const _hoisted_25 = ["aria-expanded", "onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "visitor-body" }
const _hoisted_28 = { class: "visitor-name" }
const _hoisted_29 = { class: "visitor-tags" }
const _hoisted_30 = {
  key: 0,
  class: "visitor-source"
}
const _hoisted_31 = {
  key: 1,
  class: "highlight-row"
}
const _hoisted_32 = {
  key: 0,
  class: "highlight-label"
}
const _hoisted_33 = { class: "highlight-value" }
const _hoisted_34 = {
  key: 0,
  class: "hl"
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "history-title" }, "历史搜索", -1))
const _hoisted_37 = { class: "history-list" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 2,
  class: "search-result-tip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_visitor_source_label = _resolveComponent("visitor-source-label")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container", { 'container--with-search-tip': _ctx.lastQuery }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "back-wrap",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, [
        _createVNode(_component_van_icon, {
          name: "arrow-left",
          class: "back-icon"
        })
      ]),
      _createVNode(_component_van_search, {
        modelValue: _ctx.keyword,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.keyword) = $event)),
        placeholder: "搜索聊天记录、客资信息",
        shape: "round",
        "show-action": false,
        background: "transparent",
        onSearch: _ctx.handleSearch
      }, null, 8, ["modelValue", "onSearch"])
    ]),
    (_ctx.lastQuery)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["search-tab", { active: _ctx.activeTab === 'message' }]),
              role: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTab('message')))
            }, [
              _createVNode(_component_van_icon, {
                name: "chat-o",
                class: "tab-icon"
              }),
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, "(" + _toDisplayString(_ctx.messageTotal || _ctx.messageRows.length) + ")", 1)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["search-tab", { active: _ctx.activeTab === 'visitor' }]),
              role: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTab('visitor')))
            }, [
              _createVNode(_component_van_icon, {
                name: "friends-o",
                class: "tab-icon"
              }),
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, "(" + _toDisplayString(_ctx.visitorTotal || _ctx.visitorRows.length) + ")", 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.searchLoading)
              ? (_openBlock(), _createBlock(_component_van_loading, {
                  key: 0,
                  class: "results-loading",
                  vertical: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.currentTabEmpty)
                    ? (_openBlock(), _createBlock(_component_van_empty, {
                        key: 0,
                        description: "暂无结果"
                      }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_ctx.activeTab === 'message')
                          ? (_openBlock(), _createBlock(_component_van_list, {
                              key: 0,
                              loading: _ctx.messageLoading,
                              finished: _ctx.messageFinished,
                              "finished-text": 
                  _ctx.messageRows.length === 0 ? '暂无结果' : '没有更多了'
                ,
                              onLoad: _ctx.onMessageLoad,
                              style: {"background-color":"#f7f7f7"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageRows, (row, idx) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: 'm-' + idx + '-' + row.uid,
                                    class: "msg-result-card",
                                    style: {"margin-bottom":"10px","background-color":"#fff"}
                                  }, [
                                    _createElementVNode("div", _hoisted_10, [
                                      (_ctx.visitorAvatarSrc(row.visitor))
                                        ? (_openBlock(), _createBlock(_component_van_image, {
                                            key: 0,
                                            class: "result-avatar",
                                            width: "40",
                                            height: "40",
                                            src: _ctx.visitorAvatarSrc(row.visitor)
                                          }, null, 8, ["src"]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                          _createElementVNode("div", _hoisted_13, [
                                            (
                              row.visitor.name &&
                              row.visitor.nickname &&
                              row.visitor.name !== row.visitor.nickname
                            )
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(_toDisplayString(row.visitor.name), 1),
                                                  _createElementVNode("span", _hoisted_14, "(" + _toDisplayString(row.visitor.nickname) + ")", 1)
                                                ], 64))
                                              : (row.visitor.name)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createTextVNode(_toDisplayString(row.visitor.name), 1)
                                                  ], 64))
                                                : (row.visitor.nickname)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                      _createTextVNode(_toDisplayString(row.visitor.nickname), 1)
                                                    ], 64))
                                                  : _createCommentVNode("", true)
                                          ]),
                                          (row.visitor.has_user)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "已留资"))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_16, [
                                          _createElementVNode("span", _hoisted_17, _toDisplayString(row.totalHits) + "条消息", 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.visitor.tags || [], (tag) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: tag.id || tag.text,
                                              class: "badge badge-gray"
                                            }, _toDisplayString(tag.text), 1))
                                          }), 128))
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageItemsForRow(row), (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: item.messageId || item.microtime,
                                          class: "msg-snippet-block",
                                          role: "button",
                                          onClick: _withModifiers(($event: any) => (_ctx.goToMessageConversation(row, item)), ["stop"])
                                        }, [
                                          _createElementVNode("p", _hoisted_20, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["msg-sender-tag", {
                            'msg-sender-tag--visitor': _ctx.isVisitorMessageSender(
                              item.senderType,
                            ),
                          }])
                                            }, _toDisplayString(_ctx.messageSenderTagLabel(item)), 3),
                                            _createElementVNode("span", _hoisted_21, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageItemHighlightParts(
                              item,
                            ), (part, pi) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, { key: pi }, [
                                                  (part.hit)
                                                    ? (_openBlock(), _createElementBlock("mark", _hoisted_22, _toDisplayString(part.text), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(part.text), 1))
                                                ], 64))
                                              }), 128))
                                            ])
                                          ]),
                                          (_ctx.formatSearchMessageMicrotime(item.microtime))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.formatSearchMessageMicrotime(item.microtime)), 1))
                                            : _createCommentVNode("", true)
                                        ], 8, _hoisted_19))
                                      }), 128))
                                    ]),
                                    (_ctx.messageRowShowViewAllToggle(row))
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "view-all-row",
                                          role: "button",
                                          "aria-expanded": String(_ctx.isMessageRowExpanded(row.uid)),
                                          onClick: _withModifiers(($event: any) => (_ctx.onToggleAllMessages(row)), ["stop"]),
                                          style: {"border-top":"1px solid #ebedf0","padding-top":"10px"}
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.isMessageRowExpanded(row.uid)
                        ? "收起"
                        : `查看全部${row.totalHits}条消息`), 1),
                                          _createVNode(_component_van_icon, {
                                            name: 
                        _ctx.isMessageRowExpanded(row.uid)
                          ? 'arrow-up'
                          : 'arrow-down'
                      ,
                                            class: "view-all-chevron"
                                          }, null, 8, ["name"])
                                        ], 8, _hoisted_25))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["loading", "finished", "finished-text", "onLoad"]))
                          : (_openBlock(), _createBlock(_component_van_list, {
                              key: 1,
                              loading: _ctx.visitorLoading,
                              finished: _ctx.visitorFinished,
                              "finished-text": 
                  _ctx.visitorRows.length === 0 ? '暂无结果' : '没有更多了'
                ,
                              onLoad: _ctx.onVisitorLoad
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitorRows, (row, idx) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: 'v-' + idx + '-' + row.uid,
                                    class: "visitor-result-row",
                                    onClick: ($event: any) => (_ctx.goToLead(row.uid))
                                  }, [
                                    (_ctx.visitorAvatarSrc(row))
                                      ? (_openBlock(), _createBlock(_component_van_image, {
                                          key: 0,
                                          class: "result-avatar",
                                          width: "40",
                                          height: "40",
                                          src: _ctx.visitorAvatarSrc(row)
                                        }, null, 8, ["src"]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_27, [
                                      _createElementVNode("div", _hoisted_28, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitorDisplayNameParts(row), (part, pi) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: pi }, [
                                            (part.hit)
                                              ? (_openBlock(), _createElementBlock("mark", {
                                                  key: 0,
                                                  class: _normalizeClass(["hl", { 'visitor-name-extra': part.dim }])
                                                }, _toDisplayString(part.text), 3))
                                              : (_openBlock(), _createElementBlock("span", {
                                                  key: 1,
                                                  class: _normalizeClass({ 'visitor-name-extra': part.dim })
                                                }, _toDisplayString(part.text), 3))
                                          ], 64))
                                        }), 128))
                                      ]),
                                      _createElementVNode("div", _hoisted_29, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.tags || [], (tag) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: tag.id || tag.text,
                                            class: "badge badge-gray"
                                          }, _toDisplayString(tag.text), 1))
                                        }), 128))
                                      ]),
                                      (row.platform)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                            _createVNode(_component_visitor_source_label, { visitor: row }, null, 8, ["visitor"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.visitorHighlightItems(row).length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitorHighlightItems(row), (item) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: item.field,
                                                class: "highlight-item"
                                              }, [
                                                (_ctx.showVisitorHighlightLabel(item))
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(item.label) + "：", 1))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("span", _hoisted_33, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.parts, (part, pi) => {
                                                    return (_openBlock(), _createElementBlock(_Fragment, { key: pi }, [
                                                      (part.hit)
                                                        ? (_openBlock(), _createElementBlock("mark", _hoisted_34, _toDisplayString(part.text), 1))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(part.text), 1))
                                                    ], 64))
                                                  }), 128))
                                                ])
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createVNode(_component_van_icon, {
                                      name: "arrow",
                                      class: "visitor-arrow"
                                    })
                                  ], 8, _hoisted_26))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["loading", "finished", "finished-text", "onLoad"]))
                      ]))
                ], 64))
          ])
        ], 64))
      : (_ctx.historyList.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${item}-${index}`,
                  class: "history-row"
                }, [
                  _createVNode(_component_van_icon, {
                    name: "clock-o",
                    class: "history-clock"
                  }),
                  _createElementVNode("span", {
                    class: "history-text",
                    onClick: ($event: any) => (_ctx.selectHistory(item))
                  }, _toDisplayString(item), 9, _hoisted_38),
                  _createVNode(_component_van_icon, {
                    name: "cross",
                    class: "history-clear",
                    onClick: _withModifiers(($event: any) => (_ctx.removeAt(index)), ["stop"])
                  }, null, 8, ["onClick"])
                ]))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true),
    (_ctx.lastQuery)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, " 仅支持展示近3个月内的搜索结果 "))
      : _createCommentVNode("", true)
  ], 2))
}